var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"blocker-container"},[_c('Headline',{attrs:{"headline":this.headline}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_c('ContactTel')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }